(() => {
  if (window.AyaaniHomepageQuickAddV1) return;
  window.AyaaniHomepageQuickAddV1 = true;

  const selector = '.ayr-product form[action*="/cart/add"]';

  function setLoading(form, loading) {
    const button = form.querySelector('[type="submit"]');
    if (!button) return;

    if (loading) {
      button.dataset.ayaaniOriginalText = button.textContent || 'Add to basket';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding…';
    } else {
      button.textContent = button.dataset.ayaaniOriginalText || 'Add to basket';
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      delete button.dataset.ayaaniOriginalText;
    }
  }

  function showError(form, message = '') {
    let error = form.querySelector('[data-ayaani-homepage-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.ayaaniHomepageCartError = '';
      error.setAttribute('role', 'alert');
      error.setAttribute('aria-live', 'polite');
      error.style.cssText = 'margin:8px 0 0;color:#7b1423;font-size:13px;line-height:1.35;';
      form.appendChild(error);
    }
    error.textContent = message;
    error.hidden = !message;
  }

  async function addToDrawer(event) {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.dataset.ayaaniPending === 'true') return;

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput?.value) {
      showError(form, 'This product is currently unavailable.');
      return;
    }

    form.dataset.ayaaniPending = 'true';
    setLoading(form, true);
    showError(form, '');

    try {
      const formData = new FormData(form);
      const sections = cart.getSectionsToRender().map((section) => section.id).filter(Boolean);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'This product could not be added.');
      }

      cart.classList.remove('is-empty');

      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          await Promise.resolve(window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'ayaani-homepage-quick-add',
            productVariantId: formData.get('id'),
            cartData: result,
          }));
        }
      } catch (publishError) {
        console.warn('[Ayaani homepage quick add] Cart update event could not be published.', publishError);
      }

      cart.renderContents(result);
    } catch (error) {
      console.error('[Ayaani homepage quick add] Add to basket failed.', error);
      showError(form, error.message || 'This product could not be added. Please try again.');
    } finally {
      delete form.dataset.ayaaniPending;
      setLoading(form, false);
    }
  }

  function bind(root = document) {
    const forms = [];
    if (root.matches?.(selector)) forms.push(root);
    root.querySelectorAll?.(selector).forEach((form) => forms.push(form));

    forms.forEach((form) => {
      if (form.dataset.ayaaniHomepageCartBound === 'true') return;
      form.dataset.ayaaniHomepageCartBound = 'true';
      form.querySelectorAll('[type="submit"]').forEach((button) => button.setAttribute('aria-haspopup', 'dialog'));
      form.addEventListener('submit', addToDrawer);
    });
  }

  function initialise() {
    bind(document);
    document.addEventListener('shopify:section:load', (event) => bind(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
